export default __webpack_public_path__ + "static/media/bg-list-3.5dc10802.svg";